import axios from '../axiosConfig'
import { getEnv } from '@utils/env'

const BUSINESS_LAYER_API = getEnv('REACT_APP_BUSINESS_LAYER_BILLING', '')

interface ApiResponse<T> {
  statusCode: number
  message: string
  data: T
}

export interface StripeAccountStatus {
  account_id: string
  charges_enabled: boolean
  payouts_enabled: boolean
  details_submitted: boolean
  onboarding_complete?: boolean
  requirements_due_count?: number
  currently_due?: string[]
  eventually_due?: string[]
  past_due?: string[]
  country?: string
  default_currency?: string
}

export type StripeAccountStatusResponse = ApiResponse<{
  account_status: StripeAccountStatus
}>

export type CreateStripeAccountResponse = ApiResponse<{
  stripe_account: {
    stripe_account_id: string
    clinic_id: string
    stripe_connected_account_id: string
  }
}>

export type HostedOnboardingResponse = ApiResponse<{
  url: string
  expires_at: number
}>

export type EmbeddedOnboardingResponse = ApiResponse<{
  client_secret: string
  expires_at: number
}>

export type StripeLoginLinkResponse = ApiResponse<{
  url: string
  created: number
}>

export const getStripeAccountStatus = async (
  clinicId: string,
): Promise<StripeAccountStatusResponse> => {
  const response = await axios.get<StripeAccountStatusResponse>(
    `${BUSINESS_LAYER_API}/api/v1/stripe-accounts/${clinicId}/status`,
  )
  return response.data
}

export const createStripeAccount = async (
  clinicId: string,
): Promise<CreateStripeAccountResponse> => {
  const response = await axios.post<CreateStripeAccountResponse>(
    `${BUSINESS_LAYER_API}/api/v1/stripe-accounts`,
    { clinic_id: clinicId },
  )
  return response.data
}

export const createHostedOnboardingLink = async (
  clinicId: string,
): Promise<HostedOnboardingResponse> => {
  const response = await axios.post<HostedOnboardingResponse>(
    `${BUSINESS_LAYER_API}/api/v1/stripe-accounts/${clinicId}/onboarding/hosted`,
    {},
  )
  return response.data
}

export const createEmbeddedOnboardingSession = async (
  clinicId: string,
): Promise<EmbeddedOnboardingResponse> => {
  const response = await axios.post<EmbeddedOnboardingResponse>(
    `${BUSINESS_LAYER_API}/api/v1/stripe-accounts/${clinicId}/onboarding/embedded`,
    {},
  )
  return response.data
}

export const createStripeLoginLink = async (
  clinicId: string,
): Promise<StripeLoginLinkResponse> => {
  const response = await axios.post<StripeLoginLinkResponse>(
    `${BUSINESS_LAYER_API}/api/v1/stripe-accounts/${clinicId}/login-link`,
    {},
  )
  return response.data
}
